const htmlListsNodesToLatexPrinter = (node, printChildren) => {
  var _a, _b, _c, _d;
  if (!node.children) {
    return "";
  }
  const children = printChildren(node.children);
  switch (node.tagName) {
    case "ul": {
      const mappedChildren = children.map((child) => `\\item ${child}`);
      return `\\begin{itemize}
\\tightlist
${mappedChildren.join("\n")}
\\end{itemize}
`;
    }
    case "ol": {
      const startIndex = (() => {
        var _a2;
        const base = Number((_a2 = node.attributes) == null ? void 0 : _a2["start"]);
        if (Number.isNaN(base)) {
          return 0;
        } else {
          return base - 1;
        }
      })();
      const listStyleType = ((_b = (_a = node.attributes) == null ? void 0 : _a["class"]) == null ? void 0 : _b.includes(
        "list-style-upper-latin"
      )) ? "upper-latin" : ((_d = (_c = node.attributes) == null ? void 0 : _c["class"]) == null ? void 0 : _d.includes("list-style-lower-latin")) ? "lower-latin" : "numbered";
      const marker = (() => {
        switch (listStyleType) {
          case "numbered":
            return "\\arabic";
          case "lower-latin":
            return "\\alph";
          case "upper-latin":
            return "\\Alph";
        }
      })();
      const mappedChildren = children.map((child) => `\\item ${child}`);
      return `
\\begin{enumerate}
\\tightlist
\\def\\labelenumi{${marker}{enumi}.}
\\setcounter{enumi}{${startIndex}}
${mappedChildren.join("\n")}
\\end{enumerate}
`;
    }
    default:
      return children.join("");
  }
};

export { htmlListsNodesToLatexPrinter };
//# sourceMappingURL=html.lists.js.map
